export const load = () => ({
	title: 'Storm Windows for Glass Walls and Large Windows',
	showTitle: true,
});
